<template>
 <div class="card">
   <div class="card-header">
     <p class="card-header-title">Créer contenu de champ</p>
     <span class="icon has-text-info help-btn">
       <a href="https://theadmin.thecompagnie.eu/doc?bloc=Créer%20un%20type%20de%20contenu" target="_blank"><i class="fa fa-question-circle"></i></a>
     </span>
   </div>
   <div class="card-content">
     <div class="content">
       <div class="columns">
         <div class="column is-one-third">
           <div class="field">
             <label class="label">Nom de champ</label>
             <div class="control">
               <input class="input" type="text" placeholder="Nom de champ" v-model="fieldName">
             </div>
           </div>
           <div class="field">
             <label class="label">Type de champ</label>
             <div class="control">
                <dropdown :options="fieldTypes" :selectedElement="fieldType" />
             </div>
           </div>
           <div class="field">
             <label class="label">Autoriser plusieurs valeurs</label>
             <div class="control">
                <checkbox v-model="multiValue"/>
             </div>
           </div>
         </div>
       </div>
       <div class="buttons">
         <button type="submit" class="button is-success" :disabled="fieldName === '' || fieldType.id === ''" @click="add()">Ajouter ce champ</button>
         <router-link to="/admin/content" class="button is-danger">Annuler</router-link>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import checkbox from '@/admin/components/shared/Checkbox'
import dropdown from '@/admin/components/shared/Dropdown'
import { contentsRef, fieldsRef } from '@/admin/firebase_config'
import notifier from '@/admin/mixins/notifier'
export default {
  name: 'fieldNew',
  mixins: [notifier],
  firebase: {
    contents: contentsRef,
    fields: fieldsRef
  },
  data () {
    return {
      fieldName: '',
      fieldType: {
        id: '',
        label: 'Type de champ'
      },
      multiValue: false,
      fieldTypes: [
        {
          id: 'textarea',
          label: 'Textarea'
        },
        {
          id: 'textbox',
          label: 'Textbox'
        },
        {
          id: 'integer',
          label: 'Integer'
        },
        {
          id: 'boolean',
          label: 'Boolean'
        },
        {
          id: 'url',
          label: 'Url'
        },
        {
          id: 'richtextbox',
          label: 'Richtextbox'
        },
        {
          id: 'tags',
          label: 'Tags'
        },
        {
          id: 'select',
          label: 'Select'
        },
        {
          id: 'image',
          label: 'Image'
        }
      ]
    }
  },
  props: ['add-field'],
  methods: {
    add () {
      let f = {
        name: this.fieldName,
        type: this.fieldType.id,
        multiValue: this.multiValue
      }
      this.addField(f)
      this.fieldName = ''
      this.fieldType = {
        id: '',
        label: 'Type de champ'
      }
      this.multiValue = false
      this.$router.push({ path: '/admin/content' })
    },
    resetForm () {
      this.name = ''

      for (var key in this.supports) {
        this.supports[key] = false
      }
    }
  },
  components: {
    checkbox,
    dropdown
  }
}

</script>

<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}

</style>



// WEBPACK FOOTER //
// src/admin/pages/content/fields/FieldNew.vue